import {PageInfo} from '../generated/types';

export function createPageInfo({
  hasNextPage,
  hasPreviousPage,
  startCursor,
  endCursor,
}: {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor?: string;
  endCursor?: string;
}): PageInfo {
  return {
    hasNextPage,
    hasPreviousPage,
    startCursor,
    endCursor,
  };
}
